import { useHistory } from "react-router-dom";
import { HiOutlineCheckCircle } from 'react-icons/hi';

export default function SuccessStep({ userInfo, setUserInfo, currentStep, setCurrentStep, classNames }) {

  const history = useHistory();

  return (
    <>
      <div className="mt-24 sm:mt-10 mb-6 sm:col-span-2">
        <HiOutlineCheckCircle className="w-32 h-32 mx-auto text-green-500" />
        <h1 className="mt-2 text-2xl font-medium tracking-tight text-gray-900 sm:text-4xl text-center dark:text-white">
          Account Created!
        </h1>
        <p className="text-gray-700 text-center mt-2 dark:text-gray-400">Your account has been successfully created.</p>
      </div>

      <div className="mt-6 text-sm sm:text-base gap-14 sm:gap-24 flex justify-between">
        <button
          onClick={() => { history.push("/") }}
          type="button"
          className="rounded-md w-full bg-blue-600 py-2.5 px-3.5 text-md font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Continue
        </button>
      </div>
    </>
  )
}